import React from "react";
import { Send } from "lucide-react";
import { useTranslation } from "react-i18next";

import "./GptChat.css";

export default function GptChatInput({
  title,
  description,
  placeholder = "",
  multiline = false,
  submitLabel,
  loadingLabel,
  flowId,
  stepId,
  onSubmit,
}) {
  const { t } = useTranslation("assistantAi");
  const labels = t("gptChat.input", { returnObjects: true });
  const [value, setValue] = React.useState("");
  const [submitting, setSubmitting] = React.useState(false);
  const canSubmit = Boolean(value.trim()) && !submitting;
  const finalSubmitLabel = submitLabel || labels.submit;
  const finalLoadingLabel = loadingLabel || labels.loading;

  const submit = async () => {
    if (!canSubmit) return;
    setSubmitting(true);
    try {
      await onSubmit?.({ flowId, stepId }, { message: value.trim() });
    } finally {
      setSubmitting(false);
    }
  };

  const commonProps = {
    className: "guided-gpt-input__field",
    value,
    placeholder,
    disabled: submitting,
    onChange: (event) => setValue(event.target.value),
    onKeyDown: (event) => {
      if (!multiline && event.key === "Enter") {
        event.preventDefault();
        submit();
      }
    },
  };

  return (
    <div className="guided-gpt-card">
      <div className="guided-gpt-card__header">
        <div>
          <strong>{title || labels.title}</strong>
          {description && <span>{description}</span>}
        </div>
      </div>

      {multiline ? (
        <textarea {...commonProps} rows={5} />
      ) : (
        <input {...commonProps} type="text" />
      )}

      <div className="guided-gpt-card__actions">
        {submitting && (
          <div className="guided-gpt-loading" role="status">
            <div className="guided-gpt-loading__dots">
              <span />
              <span />
              <span />
            </div>
            <p>{finalLoadingLabel}</p>
          </div>
        )}
        <button type="button" className="guided-gpt-submit" onClick={submit} disabled={!canSubmit}>
          <Send size={15} />
          <span>{finalSubmitLabel}</span>
        </button>
      </div>
    </div>
  );
}
